var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 28,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.49 14.96H13.8075V20.36C13.8075 21.155 14.7975 21.53 15.3225 20.93L21 14.48C21.495 13.9175 21.0975 13.04 20.3475 13.04H18.03V7.63998C18.03 6.84498 17.04 6.46998 16.515 7.06998L10.8375 13.52C10.35 14.0825 10.7475 14.96 11.49 14.96Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 8.5625H5.625C5.3175 8.5625 5.0625 8.3075 5.0625 8C5.0625 7.6925 5.3175 7.4375 5.625 7.4375H10.875C11.1825 7.4375 11.4375 7.6925 11.4375 8C11.4375 8.3075 11.1825 8.5625 10.875 8.5625Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 20.5625H5.625C5.3175 20.5625 5.0625 20.3075 5.0625 20C5.0625 19.6925 5.3175 19.4375 5.625 19.4375H10.125C10.4325 19.4375 10.6875 19.6925 10.6875 20C10.6875 20.3075 10.4325 20.5625 10.125 20.5625Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.875 14.5625H5.625C5.3175 14.5625 5.0625 14.3075 5.0625 14C5.0625 13.6925 5.3175 13.4375 5.625 13.4375H7.875C8.1825 13.4375 8.4375 13.6925 8.4375 14C8.4375 14.3075 8.1825 14.5625 7.875 14.5625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharging);
export default __webpack_public_path__ + "static/media/charging.0dff5623758514948f51f980801207c2.svg";
export { ForwardRef as ReactComponent };